var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgStructure = function SvgStructure(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8.4 5.7a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Zm12.6 0a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0ZM8.4 18.3a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Zm12.6 0a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    d: "M8.4 18.3h7.2M8.4 5.7h7.2m2.7 9.9V8.4M5.7 15.6V8.4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStructure);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;